export default __webpack_public_path__ + "static/media/cover-with-bg-desktop.43780406.webp";